export interface Link {
  url: string;
  text: string;
  abstract: string | null;
  cssClass: string | null;
  isActive: boolean | null;
  isOpen: boolean | null;
  target: string | null;
  editorField: string | null;
}

export const defaultLink: Link = {
  url: '',
  text: '',
  abstract: '',
  cssClass: '',
  isActive: false,
  isOpen: false,
  target: '',
  editorField: ''
};

export const defaultLinkValue = (): Link => defaultLink;

// export default Link;
